import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        page: {
            total: 0,
            records: []
        },
        pageSearch: {
            current: 1,
            size: 10,
            search: {
                source: 1,
                status: true,
                role_id: null,
                like_code: null,
                like_name: null,
                like_model_name: null,
            }
        }
    },
    getters: {
        /**
         * @return {null}
         */
        ['RolePermissionPlatformListGetPageSearchSearchRoleId'](state) {
            return state.pageSearch.search.role_id;
        },
        ['RolePermissionPlatformListGetPageSearch'](state) {
            return state.pageSearch;
        },
        ['RolePermissionPlatformListGetPageCurrent'](state) {
            return state.pageSearch.current;
        },
        ['RolePermissionPlatformListGetPageSize'](state) {
            return state.pageSearch.size;
        },
        ['RolePermissionPlatformListGetPageTotal'](state) {
            return state.page.total;
        },
    },
    mutations: {
        ['RolePermissionPlatformListSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['RolePermissionPlatformListSetPage'](state, page) {
            state.page = page;
        },
        ['RolePermissionPlatformListSetPageSearch'](state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        ['RolePermissionPlatformListSetPageSearchSearch'](state, pageSearchSearch) {
            state.pageSearch.search = pageSearchSearch;
        },
        ['RolePermissionPlatformListSetPageSearchSearchRoleId'](state, roleId) {
            state.pageSearch.search.role_id = roleId;
        },
        ['RolePermissionPlatformListSetPageCurrent'](state, pageCurrent) {
            state.pageSearch.current = pageCurrent;
        },
        ['RolePermissionPlatformListSetPageSize'](state, pageSize) {
            state.pageSearch.size = pageSize;
        }
    },
    actions: {
        async queryByPage({commit}, params) {
            commit('RolePermissionPlatformListSetLoading', true);
            commit('RolePermissionPlatformListSetPageSearch', params);
            try {
                let result = await OrganizationServer.rolePermission.page(params);
                if (result.data.code === '200') {
                    let records = result.data.data.records;
                    records.forEach(
                        p => {
                            //切分角色
                            let temp = p.extendRoleName.split(",");
                            let roles = [];
                            let index = 0;
                            temp.forEach(
                                r => {
                                    let rArr = r.split('@ATHUB@');
                                    roles.push({
                                        index: ++index,
                                        id: rArr[0],
                                        name: rArr[1]
                                    })
                                }
                            );
                            p.extendRoleName = roles;
                        }
                    );
                    result.data.data.records = records;
                    commit('RolePermissionPlatformListSetPage', result.data.data);
                }
                commit('RolePermissionPlatformListSetLoading', false);
            } catch (e) {
                console.log(e.message);
                commit('RolePermissionPlatformListSetLoading', false);
                throw e;
            }
        }
    }
}
